import React from 'react';
import { PAGE_CONFIG } from './pageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';

const reqParams = '/benchmark/explore';

const Benchmark = () => {
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={PAGE_CONFIG}/>
    </>
  );
};

export default Benchmark;

